import ApiCaller from 'actions/ApiCaller';
import baseAjaxConfig from './BaseAjaxConfig';
export var Validate2faAction;
(function (Validate2faAction) {
    Validate2faAction["REQUEST"] = "VALIDATE_2FA_REQUEST";
    Validate2faAction["SUCCESS"] = "VALIDATE_2FA_SUCCESS";
    Validate2faAction["ERROR"] = "VALIDATE_2FA_ERROR";
})(Validate2faAction || (Validate2faAction = {}));
export function validate2FaAction(params) {
    return (dispatch) => {
        dispatch({
            type: Validate2faAction.REQUEST
        });
        return ApiCaller.post(Object.assign({}, baseAjaxConfig, {
            pathname: '/api/1/user/otp/2fa/validate',
            acceptErrors: true,
            action: Validate2faAction.REQUEST
        }), params).then(json => dispatch({
            type: Validate2faAction.SUCCESS,
            data: json.RESPONSE
        }), error => {
            return Promise.reject(error['RESPONSE']);
        });
    };
}
